<template>
  <div class="Locale ">
    <BoxLang v-for="(lang, i) in locales" :key="`Lang-${i}`"  :value="lang.short" :id="i" :for="i" :lang="lang.short" />
  </div>
</template>

<script>
import BoxLang from "@/components/menu/Box"

export default {
  name: 'LocaleSwitcher',
  components: {
    BoxLang
  },
  data() {
    return {
      locales: [
        {
          short: 'en',
          long: 'English'
        },
        {
          short: 'es',
          long: 'Español'
        }
      ]
    }
  },
}
</script>

<style lang="scss">
.Locale {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  margin-top: 2vh;
}
</style>
